module.exports = __webpack_public_path__ + "img/culture2@2x.b66bd9df.png";